var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var MicIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M5.762 11.5a.24.24 0 0 1 .236.23l.012.233a6.004 6.004 0 0 0 5.988 5.537 6.004 6.004 0 0 0 5.99-5.56l.007-.209a.24.24 0 0 1 .24-.231h1.524a.24.24 0 0 1 .24.24v.01c-.003.14-.008.25-.014.335-.278 3.831-3.242 6.886-6.986 7.353v2.322a.24.24 0 0 1-.24.24h-1.522a.24.24 0 0 1-.24-.24v-2.322c-3.733-.466-6.692-3.505-6.983-7.323L4 11.749a.24.24 0 0 1 .23-.249h1.532ZM11.998 2a4.002 4.002 0 0 1 4.004 4v6c0 2.21-1.793 4-4.004 4a4.002 4.002 0 0 1-4.004-4V6c0-2.21 1.793-4 4.004-4Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default MicIcon;
